import { render, staticRenderFns } from "./WorkSection.vue?vue&type=template&id=7f24e409&"
import script from "./WorkSection.vue?vue&type=script&lang=js&"
export * from "./WorkSection.vue?vue&type=script&lang=js&"
import style0 from "./WorkSection.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports